import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAugmentedJQuery, IController, ILogService, IModule, IPromise, IScope, ITimeoutService} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {C3TodeltPieKonfig} from "../../../../../felles/komponenter/c3TodeltPie/c3TodeltPie";
import {gettextCatalog} from "angular-gettext";
import {dersomChangesInneholder} from "../../../../../felles/stoettefunk/angularHjelpemetoder";
import moment from "moment";
import {MøteRessurs} from "../../../../../felles/tjenester/ressurser/MøteRessurs";
import {MøteProsessHandlinger} from "./møteProsessHandlinger";
import {escKey_event} from "../../../../direktiver/escKey";
import {ModelloppdateringTjeneste} from "../../../../tjenester/ModelloppdateringTjeneste";
import {Kontekst} from "../../../../../felles/tjenester/Kontekst";
import {Konfigurasjon, Miljø} from "../../../../../felles/infrastruktur/Konfigurasjon";
import {Debugger} from "debug";
import {MenyTjeneste} from "../../../../komponenter/meny/meny";
import IAnimateService = angular.animate.IAnimateService;

const debug: Debugger = require('debug')('MøteProsessOversiktKontroller');

require('./møteProsessOversikt.scss');

export class MøteProsessOversiktKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmMoeteProsessOversikt', {
              bindings: {moete: '<', moetedeltaljer:'&'},
              controller: MøteProsessOversiktKontroller.forInjisering(),
              template: require('./møteProsessOversikt.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.ng.$element,
            regNavn.ng.$timeout,
            regNavn.ng.$animate,
            regNavn.ng.$log,
            regNavn.ng.$scope,
            regNavn.gettext.gettextCatalog,
            Kontekst.regNavn,
            ModelloppdateringTjeneste.regNavn,
            MøteRessurs.regNavn,
            MøteProsessHandlinger.regNavn,
            MenyTjeneste.regNavn,
            Konfigurasjon.regNavn,
            MøteProsessOversiktKontroller
        ]
    }

    constructor(private $element: IAugmentedJQuery,
                private $timeout: ITimeoutService,
                private $animate: IAnimateService,
                private $log: ILogService,
                private $scope: IScope,
                private gettextCatalog: gettextCatalog,
                private kontekst: Kontekst,
                private modelloppdatering: ModelloppdateringTjeneste,
                private møteRessurs: MøteRessurs,
                private møteProsessHandlinger: MøteProsessHandlinger,
                private menyTjeneste: MenyTjeneste,
                private konfigurasjon: Konfigurasjon) {
    }

    private moete: l.MøteModellEnkel; //settes via bindings
    private moetedeltaljer: () => IPromise<l.MøteModell>; //settes via bindings

    moetesteg = l.Moetesteg; // Dette gjør enumen tilgjengelig i html
    
    dataLastet = false;
    
    foerMoetetStegModeller: MøteProsessStegModell[];
    etterMoetetStegModeller: MøteProsessStegModell[];
    antallStegFoerMoetetSomVisesIPopup: number;
    antallStegEtterMoetetSomVisesIPopup: number;
    naavaerendeStegModell: MøteProsessStegModell;
    naavaerendeStegNummer: number;
    totaltAntallStegNummer: number;

    private møtePublisert: boolean;
    private deltakerstatusForBruker?: l.Deltakerstatus;
    private protokollPublisert: boolean;
    private protokollSigneringsstatusForBruker: l.SignatarStatus;
    private protokollSigneringStatus: l.SigneringStatus;

    private protokollenErSendtTilSigneringMelding = this.gettextCatalog.getString('Protokollen er sendt til signering. Hvis du vil låse opp møtet, kan du gjøre dette fra møtemenyen.');
    private protokollenErIkkeSendtTilSigneringMelding = this.gettextCatalog.getString('Protokollen er ikke sendt til signering.');

    popupErAapen = false;
    
    c3TodeltPieKonfig: C3TodeltPieKonfig = {
        ikkePåbegyntBakgrunnsFarge: '#ffffff00', // transparent farge gir riktig hover-effekt inni md-button
        ikkePåbegyntBorderFarge: '#1565c0', // samme som $std-farge-tekst-lenke i _definisjoner.scss
        restFarge: '#ffffff00', // transparent farge gir riktig hover-effekt inni md-button
        hovedFarge: '#1565c0', // samme som $std-farge-tekst-lenke i _definisjoner.scss
        fullførtFarge: '#1565c0', // samme som $std-farge-tekst-lenke i _definisjoner.scss
        interaksjonAktivert: false,
        termineringsTimeout: 500
    }

    private windowClickHandler: (eventObject: JQueryEventObject) => void;
    private lastDataNårMøtetStarterTimeout: IPromise<any>;

    menyDeaktivert(){
        return this.menyTjeneste.erDeaktivert();
    }

    naavaerendeStegType():'knapp'|'godtaAvslå'|'knappUtenHandling'{
        if ([this.moetesteg.moetet_er_under_arbeid, this.moetesteg.protokollen_er_under_arbeid, this.moetesteg.du_har_godtatt_innkallingen, this.moetesteg.du_har_avslaatt_innkallingen]
            .includes(this.naavaerendeStegModell.steg))
            return 'knappUtenHandling';

        if (this.naavaerendeStegModell.steg === this.moetesteg.svar_paa_innkalling)
            return 'godtaAvslå';

        return 'knapp';
    }
    
    $onInit(): void {
        this.windowClickHandler = (eventObject: JQueryEventObject) => {
            const klikkSkjeddeIPopup =
              angular.element(eventObject.target).parents('[data-wm-mpo-forhindre-klikk-bobling="1"]').length > 0 ||
              angular.element(eventObject.target).is('[data-wm-mpo-forhindre-klikk-bobling="1"]');

            if (!klikkSkjeddeIPopup) {
                // $timeout er tatt med for at Angular skal få med seg endringene som gjøres inni den
                this.$timeout(() => {
                    this.lukkPopup();
                })
            }
        };

        this.$element.parents('ui-view').last().on('click', this.windowClickHandler);

        this.$scope.$on(escKey_event, () => this.lukkPopup());
        
        this.lyttTilNySak();
        this.lyttTilMøtedeltakerOppdatert();
        this.lyttTilMøtedeltakereOppdatert();
        this.lyttTilSignatarSignert();
    }

    $onDestroy(): void {
        this.$element.parents('ui-view').last().off('click', this.windowClickHandler);

        this.$timeout.cancel(this.lastDataNårMøtetStarterTimeout);
    }
    
    $onChanges(endringer: angular.IOnChangesObject) {
        dersomChangesInneholder(endringer, 'moete', () => {
            this.lastData();
            this.registrerTimeoutForÅLasteDataNårMøtetStarter();
        })
    }

    aapneEllerLukkPopup() {
        if (this.menyTjeneste.erDeaktivert()) return;
        this.popupErAapen = !this.popupErAapen;
    }
    
    lukkPopup() {
        this.popupErAapen = false;
    }
    
    haandterKlikkPaaSteg(stegModell: MøteProsessStegModell) {
        if (stegModell.handling) {
            stegModell.handling();
        } else {
            this.$log.warn(`Kan ikke håndtere klikk fordi handling ikke finnes for steget: ${stegModell.steg}`);
        }
        
        this.lukkPopup();
    }
    
    godtaInnkalling() {
        this.møteProsessHandlinger.godtaInnkalling(this.moete);
    }
    
    avslaaInnkalling() {
        this.møteProsessHandlinger.avslåInnkalling(this.moete);
    }

    // hjelpemetoder
    
    private lastData() {
        this.hentMøteStatus();
    }
    
    private hentMøteStatus() {
        this.møteRessurs.hentStatus(this.moete.id).$promise
          .then((modell: l.MoetestatusModell) => {
              this.møtePublisert = modell.moetePublisert;
              this.deltakerstatusForBruker = modell.deltakerstatusForBruker;
              this.protokollPublisert = modell.protokollPublisert;
              this.protokollSigneringsstatusForBruker = modell.protokollSigneringsstatusForBruker;
              this.protokollSigneringStatus = modell.protokollSigneringStatus;

              const muligeStegModeller: MøteProsessStegModell[] = modell.muligeSteg.map(moetestegModell => {
                  const steg = moetestegModell.steg;
                  const progresjon = moetestegModell.progresjon;

                  if (steg === l.Moetesteg.opprett_saker)                     { return this.lagModellForOpprettSaker(progresjon); }
                  else if (steg === l.Moetesteg.publiser_moetet)              { return this.lagModellForPubliserMøtet(progresjon); }
                  else if (steg === l.Moetesteg.send_innkalling)              { return this.lagModellForSendInnkalling(progresjon); }
                  else if (steg === l.Moetesteg.svar_paa_innkalling)          { return this.lagModellForSvarPåInnkalling(progresjon); }

                  else if (steg === l.Moetesteg.skriv_protokoll)              { return this.lagModellForSkrivProtokoll(progresjon); }
                  else if (steg === l.Moetesteg.publiser_protokoll)           { return this.lagModellForPubliserProtokoll(progresjon); }
                  else if (steg === l.Moetesteg.send_til_signering)           { return this.lagModellForSendTilSignering(progresjon); }
                  else if (steg === l.Moetesteg.signer_protokoll)             { return this.lagModellForSignerProtokoll(progresjon); }
                  else if (steg === l.Moetesteg.venter_paa_signaturer)        { return this.lagModellForVenterPåSignaturer(progresjon); }
                  else if (steg === l.Moetesteg.protokoll_ferdig_signert)     { return this.lagModellForProtokollFerdigSignert(progresjon); }

                  else if (steg === l.Moetesteg.moetet_er_under_arbeid)       { return this.lagModellForMøtetErUnderArbeid(); }
                  else if (steg === l.Moetesteg.du_har_godtatt_innkallingen)  { return this.lagModellForDuHarGodtattInnkallingen(); }
                  else if (steg === l.Moetesteg.du_har_avslaatt_innkallingen) { return this.lagModellForDuHarAvslåttInnkallingen(); }
                  else if (steg === l.Moetesteg.protokollen_er_under_arbeid)  { return this.lagModellForProtokollenErUnderArbeid(); }
                  else if (steg === l.Moetesteg.du_har_signert_protokollen)   { return this.lagModellForDuHarSignertProtokollen(); }
                  else { this.$log.error(`Det er ikke implementert håndtering av Moetesteg-et: ${steg}`) }
              })

              const førMøtetStegModeller: MøteProsessStegModell[] = [];
              const etterMøtetStegModeller: MøteProsessStegModell[] = [];

              for (const stegModell of muligeStegModeller) {
                  const steg = stegModell.steg;

                  if (steg === l.Moetesteg.opprett_saker)                 { førMøtetStegModeller.push(stegModell); }
                  else if (steg === l.Moetesteg.publiser_moetet)          { førMøtetStegModeller.push(stegModell); }
                  else if (steg === l.Moetesteg.send_innkalling)          { førMøtetStegModeller.push(stegModell); }
                  else if (steg === l.Moetesteg.svar_paa_innkalling)      { førMøtetStegModeller.push(stegModell); }

                  else if (steg === l.Moetesteg.skriv_protokoll)          { etterMøtetStegModeller.push(stegModell); }
                  else if (steg === l.Moetesteg.publiser_protokoll)       { etterMøtetStegModeller.push(stegModell); }
                  else if (steg === l.Moetesteg.send_til_signering)       { etterMøtetStegModeller.push(stegModell); }
                  else if (steg === l.Moetesteg.signer_protokoll)         { etterMøtetStegModeller.push(stegModell); }
                  else if (steg === l.Moetesteg.venter_paa_signaturer)    { etterMøtetStegModeller.push(stegModell); }
                  else if (steg === l.Moetesteg.protokoll_ferdig_signert) { etterMøtetStegModeller.push(stegModell); }
              }

              this.foerMoetetStegModeller = førMøtetStegModeller;
              this.etterMoetetStegModeller = etterMøtetStegModeller;

              this.antallStegFoerMoetetSomVisesIPopup = førMøtetStegModeller.filter(stegModell => stegModell.visesIPopup).length;
              this.antallStegEtterMoetetSomVisesIPopup = etterMøtetStegModeller.filter(stegModell => stegModell.visesIPopup).length;

              this.naavaerendeStegModell = muligeStegModeller.find(stegModell => stegModell.steg === modell.aktivtSteg.steg);

              this.naavaerendeStegNummer = this.beregnNåværendeStegNummer(this.naavaerendeStegModell, muligeStegModeller);
              this.totaltAntallStegNummer = muligeStegModeller.filter(stegModell => stegModell.visesIPopup).length;
              
              this.dataLastet = true;
          })
    }
    
    private beregnNåværendeStegNummer(nåværendeStegModell: MøteProsessStegModell, muligeStegModeller: MøteProsessStegModell[]): number {
        let naavaerendeStegNummer = 0;
        for (const stegModell of muligeStegModeller) {
            if (stegModell.visesIPopup) {
                naavaerendeStegNummer += 1;
            }

            if (stegModell.steg === nåværendeStegModell.steg) {
                break;
            }
        }
        
        return naavaerendeStegNummer;
    }

    private registrerTimeoutForÅLasteDataNårMøtetStarter() {
        this.$timeout.cancel(this.lastDataNårMøtetStarterTimeout);

        const nå = moment();
        const møteStart = moment(this.moete.dato.start);
        const antallMillisekunderTilMøteStart = møteStart.diff(nå, 'milliseconds');

        if (møteStart.isSame(nå, 'day') && møteStart.isAfter(nå)) {
            //kan ikke bruke lengevarende $timeout ved kjøring av e2e-tester da protractor vil vente på at timeout løper ut
            if (this.konfigurasjon.miljø != Miljø.e2etest){
                this.lastDataNårMøtetStarterTimeout = this.$timeout(
                    () => this.lastData(),
                    antallMillisekunderTilMøteStart + 15000);
            }
        }
    }

    private lysOppSvarPaaInnkallingKnapper() {
        if (this.naavaerendeStegModell.steg !== l.Moetesteg.svar_paa_innkalling) {
            return;
        }
        
        const fokusKlasse = 'std-flash';
        const knappKontainer = this.$element.find('#wm-mpo-hovedrad-knapp-kontainer');
        knappKontainer.removeClass(fokusKlasse);//fjern eventuell kjørende animasjon
        this.$animate.addClass(knappKontainer, fokusKlasse)
          .then(() => this.$animate.removeClass(knappKontainer, fokusKlasse));
    }
    
    // Opprettelse av stegModeller
    
    private lagModellForOpprettSaker(progresjon: l.MoetestegProgresjon): MøteProsessStegModell {
        let handling: () => void;
        let handlingKanIkkeUtfoeresInformasjon: HandlingKanIkkeUtføresInformasjon;

        if (this.protokollSigneringStatus !== l.SigneringStatus.ikkeAktivert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.protokollenErSendtTilSigneringMelding
            };
        } else {
            handling = () => {
                this.moetedeltaljer()
                  .then(møte => this.møteProsessHandlinger.opprettSaker(møte));
            };
        }

        return {
            steg: l.Moetesteg.opprett_saker,
            tittel: this.gettextCatalog.getString('Opprett saker'),
            visesIPopup: true,
            progresjon: progresjon,
            handling: handling,
            handlingKanIkkeUtfoeresInformasjon: handlingKanIkkeUtfoeresInformasjon
        }
    }
    
    private lagModellForPubliserMøtet(progresjon: l.MoetestegProgresjon): MøteProsessStegModell {
        let handling: () => void;
        let handlingKanIkkeUtfoeresInformasjon: HandlingKanIkkeUtføresInformasjon;

        if (this.protokollSigneringStatus !== l.SigneringStatus.ikkeAktivert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.protokollenErSendtTilSigneringMelding
            };
        } else if (this.møtePublisert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.gettextCatalog.getString('Møtet er publisert.'), 
                alternativHandling: {
                    beskrivelse: this.gettextCatalog.getString('oppheve publiseringen'),
                    handling: () => {
                        this.møteProsessHandlinger.opphevPubliseringenAvMøtet(this.moete);
                    }
                }
            }
        } else {
            handling = () => {
                this.moetedeltaljer()
                  .then(møte => this.møteProsessHandlinger.publiserMøtet(møte));
            };
        }

        return {
            steg: l.Moetesteg.publiser_moetet,
            tittel: this.gettextCatalog.getString('Publiser møtet'),
            visesIPopup: true,
            progresjon: progresjon,
            handling: handling,
            handlingKanIkkeUtfoeresInformasjon: handlingKanIkkeUtfoeresInformasjon
        }
    }

    private lagModellForSendInnkalling(progresjon: l.MoetestegProgresjon): MøteProsessStegModell {
        let handling: () => void;
        let handlingKanIkkeUtfoeresInformasjon: HandlingKanIkkeUtføresInformasjon;

        if (this.protokollSigneringStatus !== l.SigneringStatus.ikkeAktivert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.protokollenErSendtTilSigneringMelding
            };
        } else if (progresjon.andel === progresjon.totalt && progresjon.totalt > 0) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.gettextCatalog.getString('Innkalling er sendt.')
            }
        } else {
            handling = () => {
                this.møteProsessHandlinger.sendInnkalling(this.moete);
            };
        }

        return {
            steg: l.Moetesteg.send_innkalling,
            tittel: this.gettextCatalog.getString('Send innkalling'),
            visesIPopup: true,
            progresjon: progresjon,
            tooltip: this.gettextCatalog.getString('Innkalling er sendt til {{andel}} av {{totalt}}', {
                andel: progresjon.andel,
                totalt: progresjon.totalt
            }),
            handling: handling,
            handlingKanIkkeUtfoeresInformasjon: handlingKanIkkeUtfoeresInformasjon
        }
    }

    private lagModellForSvarPåInnkalling(progresjon: l.MoetestegProgresjon): MøteProsessStegModell {
        let handling: () => void;
        let handlingKanIkkeUtfoeresInformasjon: HandlingKanIkkeUtføresInformasjon;

        if (this.protokollSigneringStatus !== l.SigneringStatus.ikkeAktivert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.protokollenErSendtTilSigneringMelding
            }
        } else if (this.deltakerstatusForBruker === l.Deltakerstatus.innkalling_ikke_sendt) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.gettextCatalog.getString('Du er ikke innkalt til dette møtet.')
            };
        } else if (this.deltakerstatusForBruker === l.Deltakerstatus.akseptert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.gettextCatalog.getString('Du har godtatt.'),
                alternativHandling: {
                    beskrivelse: this.gettextCatalog.getString('avslå'),
                    handling: () => {
                        this.møteProsessHandlinger.avslåInnkalling(this.moete);
                    }
                }
            };
        } else if (this.deltakerstatusForBruker === l.Deltakerstatus.avslaatt) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.gettextCatalog.getString('Du har avslått.'),
                alternativHandling: {
                    beskrivelse: this.gettextCatalog.getString('godta'),
                    handling: () => {
                        this.møteProsessHandlinger.godtaInnkalling(this.moete);
                    }
                }
            };
        } else {
            handling = () => {
                this.lysOppSvarPaaInnkallingKnapper();
            };
        }

        return {
            steg: l.Moetesteg.svar_paa_innkalling,
            tittel: this.gettextCatalog.getString('Svar på innkalling'),
            visesIPopup: true,
            progresjon: progresjon,
            handling: handling,
            handlingKanIkkeUtfoeresInformasjon: handlingKanIkkeUtfoeresInformasjon
        }
    }

    private lagModellForSkrivProtokoll(progresjon: l.MoetestegProgresjon): MøteProsessStegModell {
        let handling: () => void;
        let handlingKanIkkeUtfoeresInformasjon: HandlingKanIkkeUtføresInformasjon;

        if (this.protokollSigneringStatus !== l.SigneringStatus.ikkeAktivert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.protokollenErSendtTilSigneringMelding
            };
        } else {
            handling = () => {
                this.møteProsessHandlinger.skrivProtokoll(this.moete);
            }
        }

        return {
            steg: l.Moetesteg.skriv_protokoll,
            tittel: this.gettextCatalog.getString('Skriv protokoll'),
            visesIPopup: true,
            progresjon: progresjon,
            tooltip: this.gettextCatalog.getString('{{andel}} av {{totalt}} saker har protokoll', {
                andel: progresjon.andel,
                totalt: progresjon.totalt
            }),
            handling: handling,
            handlingKanIkkeUtfoeresInformasjon: handlingKanIkkeUtfoeresInformasjon
        }
    }

    private lagModellForPubliserProtokoll(progresjon: l.MoetestegProgresjon): MøteProsessStegModell {
        let handling: () => void;
        let handlingKanIkkeUtfoeresInformasjon: HandlingKanIkkeUtføresInformasjon;

        if (this.protokollSigneringStatus !== l.SigneringStatus.ikkeAktivert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.protokollenErSendtTilSigneringMelding
            };
        } else if (this.protokollPublisert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.gettextCatalog.getString('Protokollen er publisert.'), 
                alternativHandling: {
                    beskrivelse: this.gettextCatalog.getString('oppheve publiseringen'),
                    handling: () => {
                        this.møteProsessHandlinger.opphevPubliseringenAvProtokollen(this.moete);
                    }
                }
            }
        } else {
            handling = () => {
                this.moetedeltaljer()
                  .then(møte => this.møteProsessHandlinger.publiserProtokoll(møte));
            }
        }

        return {
            steg: l.Moetesteg.publiser_protokoll,
            tittel: this.gettextCatalog.getString('Publiser protokollen'),
            visesIPopup: true,
            progresjon: progresjon,
            handling: handling,
            handlingKanIkkeUtfoeresInformasjon: handlingKanIkkeUtfoeresInformasjon
        }
    }

    private lagModellForSendTilSignering(progresjon: l.MoetestegProgresjon): MøteProsessStegModell {
        let handling: () => void;
        let handlingKanIkkeUtfoeresInformasjon: HandlingKanIkkeUtføresInformasjon;

        if (this.protokollSigneringStatus !== l.SigneringStatus.ikkeAktivert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.protokollenErSendtTilSigneringMelding
            };
        } else {
            handling = () => {
                this.moetedeltaljer()
                  .then(møte => this.møteProsessHandlinger.sendTilSignering(møte));
            }
        }

        return {
            steg: l.Moetesteg.send_til_signering,
            tittel: this.gettextCatalog.getString('Send til signering'),
            visesIPopup: true,
            progresjon: progresjon,
            handling: handling,
            handlingKanIkkeUtfoeresInformasjon: handlingKanIkkeUtfoeresInformasjon
        }
    }

    private lagModellForSignerProtokoll(progresjon: l.MoetestegProgresjon): MøteProsessStegModell {
        let handling: () => void;
        let handlingKanIkkeUtfoeresInformasjon: HandlingKanIkkeUtføresInformasjon;

        if (this.protokollSigneringStatus === l.SigneringStatus.ikkeAktivert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.gettextCatalog.getString('Protokollen er ikke sendt til signering.')
            };
        } else if (this.protokollSigneringsstatusForBruker === l.SignatarStatus.signert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.gettextCatalog.getString('Du har signert protokollen.')
            };
        } else {
            handling = () => {
                this.møteProsessHandlinger.signerProtokoll(this.moete);
            };
        }

        return {
            steg: l.Moetesteg.signer_protokoll,
            tittel: this.gettextCatalog.getString('Signer protokollen'),
            visesIPopup: true,
            progresjon: progresjon,
            handling: handling,
            handlingKanIkkeUtfoeresInformasjon: handlingKanIkkeUtfoeresInformasjon
        }
    }

    private lagModellForVenterPåSignaturer(progresjon: l.MoetestegProgresjon): MøteProsessStegModell {
        let handling: () => void;
        let handlingKanIkkeUtfoeresInformasjon: HandlingKanIkkeUtføresInformasjon;

        if (this.protokollSigneringStatus === l.SigneringStatus.ikkeAktivert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.protokollenErIkkeSendtTilSigneringMelding
            };
        } else if (this.protokollSigneringStatus === l.SigneringStatus.signert
          || this.protokollSigneringStatus === l.SigneringStatus.signertOgKonvoluttert
          || this.protokollSigneringStatus === l.SigneringStatus.eksterntSignert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.gettextCatalog.getString('Protokollen er ferdig signert.')
            };
        } else {
            handling = () => {
                this.møteProsessHandlinger.venterPåSignaturer(this.moete);
            };
        }

        return {
            steg: l.Moetesteg.venter_paa_signaturer,
            tittel: this.gettextCatalog.getString('Venter på signaturer'),
            visesIPopup: true,
            progresjon: progresjon,
            tooltip: this.gettextCatalog.getString('{{andel}} av {{totalt}} har signert', {
                andel: progresjon.andel,
                totalt: progresjon.totalt
            }),
            handling: handling,
            handlingKanIkkeUtfoeresInformasjon: handlingKanIkkeUtfoeresInformasjon
        }
    }

    private lagModellForProtokollFerdigSignert(progresjon: l.MoetestegProgresjon): MøteProsessStegModell {
        let handling: () => void;
        let handlingKanIkkeUtfoeresInformasjon: HandlingKanIkkeUtføresInformasjon;

        if (this.protokollSigneringStatus === l.SigneringStatus.ikkeAktivert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.protokollenErIkkeSendtTilSigneringMelding
            };
        } else if (this.protokollSigneringStatus === l.SigneringStatus.tilSignering || this.protokollSigneringStatus === l.SigneringStatus.delvisSignert) {
            handlingKanIkkeUtfoeresInformasjon = {
                melding: this.gettextCatalog.getString('Protokollen er ikke ferdig signert.')
            };
        } else {
            handling = () => {
                this.møteProsessHandlinger.protokollFerdigSignert(this.moete);
            };
        }

        return {
            steg: l.Moetesteg.protokoll_ferdig_signert,
            tittel: this.gettextCatalog.getString('Protokollen er ferdig signert'),
            visesIPopup: true,
            progresjon: progresjon,
            handling: handling,
            handlingKanIkkeUtfoeresInformasjon: handlingKanIkkeUtfoeresInformasjon
        }
    }

    private lagModellForMøtetErUnderArbeid(): MøteProsessStegModell {
        return {
            steg: l.Moetesteg.moetet_er_under_arbeid,
            tittel: this.gettextCatalog.getString('Møtet er under arbeid'),
            visesIPopup: false,
        }
    }
    
    private lagModellForDuHarGodtattInnkallingen(): MøteProsessStegModell {
        // Handling er kommentert ut fordi den ikke er implementert - se kommentar i møteProsessHandlinger
        
        return {
            steg: l.Moetesteg.du_har_godtatt_innkallingen,
            tittel: this.gettextCatalog.getString('Du har godtatt innkallingen'),
            visesIPopup: false,
            // handling: () => {
            //     this.møteProsessHandlinger.duHarGodtattInnkallingen(this.moete);
            // }
        }
    }
    
    private lagModellForDuHarAvslåttInnkallingen(): MøteProsessStegModell {
        // Handling er kommentert ut fordi den ikke er implementert - se kommentar i møteProsessHandlinger
        
        return {
            steg: l.Moetesteg.du_har_avslaatt_innkallingen,
            tittel: this.gettextCatalog.getString('Du har avslått innkallingen'),
            visesIPopup: false,
            // handling: () => {
            //     this.møteProsessHandlinger.duHarAvslåttInnkallingen(this.moete);
            // }
        }
    }
    
    private lagModellForProtokollenErUnderArbeid(): MøteProsessStegModell {
        return {
            steg: l.Moetesteg.protokollen_er_under_arbeid,
            tittel: this.gettextCatalog.getString('Protokollen er under arbeid'),
            visesIPopup: false,
        }
    }
    
    private lagModellForDuHarSignertProtokollen(): MøteProsessStegModell {
        return {
            steg: l.Moetesteg.du_har_signert_protokollen,
            tittel: this.gettextCatalog.getString('Du har signert protokollen'),
            visesIPopup: false,
            handling: () => {
                this.møteProsessHandlinger.duHarSignertProtokollen(this.moete);
            }
        }
    }
    
    // modelloppdateringslyttere
    
    private lyttTilNySak() {
        // Vi reagerer kun hvis dette er den første saken som opprettes i møtet
        this.modelloppdatering.vedNySak(
          info => info.moeteId === this.moete?.id,
          this.$scope,
          info => {
              this.moetedeltaljer()
                .then(møte => {
                    if(møte?.saker.length !== 1) return;
                    this.lastData()
                });
          });
    }

    private lyttTilMøtedeltakerOppdatert() {
        this.modelloppdatering.vedMøtedeltakerOppdatert(
          info => info.moeteId === this.moete?.id, //kan ikke sjekke mot info.deltaker da vi ikke nødvendigvis har møtedetaljer lastet
          this.$scope,
          info => {
              this.moetedeltaljer()
                .then(detaljer => {
                    if (detaljer.deltakere.some(deltaker => deltaker.id === info.moetedeltakerId && deltaker.medlem.brukerId !== this.kontekst.autentisertBrukersId()))
                        return;
                    this.lastData()
                });
          });
    }
    
    private lyttTilMøtedeltakereOppdatert() {
        this.modelloppdatering.vedMøtedeltakereOppdatert(
          moeteId => moeteId === this.moete?.id,
          this.$scope,
          moeteId => this.lastData());
    }
    
    private lyttTilSignatarSignert() {
        this.modelloppdatering.vedSignatarSignert(
          info => info.dokumentId === this.moete?.protokolldokumentId,
          this.$scope,
          info => this.lastData());
    }
    
}


export interface HandlingKanIkkeUtføresInformasjon {
    melding: string,
    alternativHandling?: {
        beskrivelse: string,
        handling: () => void
    }
}

export interface MøteProsessStegModell {
    steg: l.Moetesteg,
    tittel: string,
    visesIPopup: boolean,
    progresjon?: {
        andel: number,
        totalt: number
    },
    tooltip?: string,
    handling?: () => void,
    handlingKanIkkeUtfoeresInformasjon?: HandlingKanIkkeUtføresInformasjon
}
